var render = function render(){var _vm=this,_c=_vm._self._c;return _c('info-tool-tip',{staticClass:"security-info-tooltip",attrs:{"text":'המידע שלך מאובטח תחת הסטנדרטים הגבוהים ביותר של אבטחת מידע',"icon-path":"/images/onboarding/icons/privacy.svg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }